import Core from '../plugin-core-system/core.class.js';
import Cookies from 'js-cookie';

export default class CsAccessibilityAnimation extends Core {

  static options = {
    playAnimationsByDefault: true,
    cookieName: 'cs-animations',
    playIconClass: 'cs-icon-play-circle-solid',
    pauseIconClass: 'cs-icon-pause-circle'
  };

  handleAnimations(startAnimation) {
    const body = document.querySelector('body');
    const splideSliders = document.getElementsByClassName('splide splide--home');
    const triggerButton = this.el;

    if (startAnimation) {

      // If there is a Progress Slider, a custom event is triggered
      if (splideSliders.length > 0) {
        const event = new CustomEvent('splideSlidersFound', {
          detail: {
            found: true
          }
        });
        document.dispatchEvent(event);
      }

      // start css animation
      body.classList.remove('h-stop-animations');

      // swap icon for trigger
      triggerButton.classList.remove('cs-icon-play-circle-solid');
      triggerButton.classList.add('cs-icon-pause-circle');

      // set title and aria-label
      triggerButton.setAttribute('title', triggerButton.dataset.titleStopAnimations);
      triggerButton.setAttribute('aria-label', triggerButton.dataset.titleStopAnimations);

      // set Cookie
      Cookies.set(CsAccessibilityAnimation.options.cookieName, '1');
    } else {

      // If there is a Progress Slider, a custom event is triggered
      if (splideSliders.length > 0) {
        const event = new CustomEvent('splideSlidersFound', {
          detail: {
            found: false
          }
        });
        document.dispatchEvent(event);
      }

      // stop css animation immediately
      body.classList.add('h-stop-animations');

      // swap icon for trigger
      triggerButton.classList.add('cs-icon-play-circle-solid');
      triggerButton.classList.remove('cs-icon-pause-circle');

      // set title and aria-label
      triggerButton.setAttribute('title', triggerButton.dataset.titleStartAnimations);
      triggerButton.setAttribute('aria-label', triggerButton.dataset.titleStartAnimations);

      // set Cookie
      Cookies.set(CsAccessibilityAnimation.options.cookieName, '0');
    }
  }

  initAnimations() {
    if (!Cookies.get(CsAccessibilityAnimation.options.cookieName)) {

      // Cookie is not set yet
      this.handleAnimations(CsAccessibilityAnimation.options.playAnimationsByDefault);
    } else {

      // Cookie is set
      this.handleAnimations(Cookies.get(CsAccessibilityAnimation.options.cookieName) === '1');
    }
  }

  initToggleButton() {
    this.el.addEventListener('click', () => {
      this.handleAnimations(Cookies.get(CsAccessibilityAnimation.options.cookieName) !== '1');
    });
  }

  init() {
    this.initAnimations();
    this.initToggleButton();
  }
}
